// extracted by mini-css-extract-plugin
module.exports = {"inspectionProcessWrap":"iVvfK","processCardGrid":"Fts07","ctaWrap":"BuMcG"};